import MuiAlert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ConfigLogo from "../../components/config-logo";
import fileTransferService from "../../services/file-transfer";
import { getStore } from "../../services/store";

const useStyles = makeStyles((theme) => ({
	textCenter: {
		textAlign: "center",
	},
	progressBox: {
		width: "340px",
		padding: "20px",
		position: "absolute",
		top: "50%",
		left: "50%",
		margin: "-70px 0 0 -170px",
		borderRadius: "4px",
		backgroundColor: theme.palette.blueBackground.main,
		color: theme.palette.lightGreyText.main,
	},
}));

const DownloadFileView = (props) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const [percentageComplete, setPercentageComplete] = React.useState(0);
	const [nextStep, setNextStep] = React.useState("");
	const [processing, setProcessing] = React.useState(false);
	const [errors, setErrors] = React.useState([]);
	const creditBuyAddress = getStore().getState().server.credit_buy_address;
	const { id } = useParams();

	let openRequests = 0;
	let closedRequest = 0;

	React.useEffect(() => {
		fileTransferService.register("download_started", (max) => {
			setProcessing(true);
			openRequests = max + 1;
		});

		fileTransferService.register("download_step_complete", (newNextStep) => {
			closedRequest = closedRequest + 1;
			setPercentageComplete(
				Math.round((closedRequest / openRequests) * 1000) / 10,
			);
			setNextStep(newNextStep);
		});

		fileTransferService.register("download_complete", () => {
			closedRequest = closedRequest + 1;
			setPercentageComplete(100);
			setProcessing(true);
			setNextStep("DOWNLOAD_COMPLETED");
		});

		const onSuccess = (data) => {
			// pass
		};

		const onError = (data) => {
			if (Object.hasOwn(data, "non_field_errors")) {
				setErrors(data.non_field_errors);
				setNextStep("");
				setProcessing(false);
			} else {
				console.log(data);
				alert("Error, should not happen.");
			}
		};
		fileTransferService.downloadFileByStorageId(id).then(onSuccess, onError);
	}, []);

	return (
		<div className={`${classes.textCenter} ${classes.progressBox}`}>
			<ConfigLogo
				configKey={"logo"}
				defaultLogo={"img/logo.png"}
				height="100%"
			/>
			<a
				href="https://psono.com/"
				target="_blank"
				rel="noopener"
				className="infolabel"
			>
				<i className="fa fa-info-circle" aria-hidden="true" />
			</a>

			{processing && (
				<Box display="flex" alignItems="center">
					<Box width="100%" mr={1}>
						<LinearProgress variant="determinate" value={percentageComplete} />
					</Box>
					<Box minWidth={35}>
						<span style={{ color: "white", whiteSpace: "nowrap" }}>
							{percentageComplete} %
						</span>
					</Box>
				</Box>
			)}
			{processing && <span>{t(nextStep)}</span>}

			{errors.length > 0 && (
				<div className="form-group alert alert-danger" ng-repeat="e in errors">
					<strong>{t("ERROR")}:</strong>

					{errors.map((prop, index) => {
						return (
							<MuiAlert
								onClose={() => {
									setErrors([]);
								}}
								key={index}
								severity="error"
								style={{ marginBottom: "5px" }}
							>
								{(prop !== "INSUFFICIENT_FUNDS" || !creditBuyAddress) && (
									<span>{t(prop)}</span>
								)}
								{prop === "INSUFFICIENT_FUNDS" && creditBuyAddress && (
									<span>{t("INSUFFICIENT_FUNDS_WITH_CREDIT_BUY_ADDRESS")}</span>
								)}
								{prop === "INSUFFICIENT_FUNDS" && creditBuyAddress && (
									<a
										href={creditBuyAddress}
										rel="nofollow noopener"
										target="_blank"
									>
										<span>{t("BUY")}</span>
									</a>
								)}
							</MuiAlert>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default DownloadFileView;
